import { render, staticRenderFns } from "./ContactFiche.vue?vue&type=template&id=08308079&"
import script from "./ContactFiche.vue?vue&type=script&lang=js&"
export * from "./ContactFiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports